import { Item } from "./Item";
import { Label } from "./Label";
import { Root } from "./Root";

export const SuggestionMenu = {
  Root,
  Item,
  EmptyItem: () => <div>Empty Item</div>,
  Label,
  Loader: () => <div>Suggestion Loader</div>,
};
